module.exports = __webpack_public_path__ + "pt.svg?f52049b0245f00f7d16eccdbe841f241";